export function getUserData() {
  const _user = {};

  try {
    _user.email = JSON.parse(JSON.parse(localStorage.getItem('persist:i2c_auth')).user).email;
    _user.guid = JSON.parse(JSON.parse(localStorage.getItem('persist:i2c_auth')).user).guid;
    _user.name = JSON.parse(JSON.parse(localStorage.getItem('persist:i2c_auth')).user).name;
    _user.lastname = JSON.parse(JSON.parse(localStorage.getItem('persist:i2c_auth')).user).lastname;
    _user.role_guid = JSON.parse(JSON.parse(localStorage.getItem('persist:i2c_auth')).user).role_guid;
    _user.role_name = JSON.parse(JSON.parse(localStorage.getItem('persist:i2c_auth')).user).role_name;
    _user.username = JSON.parse(JSON.parse(localStorage.getItem('persist:i2c_auth')).user).username;
    _user.source = JSON.parse(JSON.parse(localStorage.getItem('persist:i2c_auth')).user).source;
  } catch (e_b2) {
    console.debug(e_b2);
  }

  return _user;
}

export function getToken() {
  let __token = '';
  try {
    __token = JSON.parse(localStorage.getItem('session')).token;
  } catch (e_b1) {
    console.debug(e_b1);
  }
  try {
    __token = JSON.parse(localStorage.getItem('persist:i2c_auth')).authToken.replaceAll('"', '');
  } catch (e_b2) {
    console.debug(e_b2);
  }
  return __token;
}

export function getUrlParam(sParam) {
  try {
    let sPageURL = decodeURIComponent(window.location.search.substring(1));

    if (sPageURL == '') {
      sPageURL = window.location.href;
      sPageURL = sPageURL.split('?')[1];
    }

    const sURLVariables = sPageURL.split('&');
    let sParameterName;
    let i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  } catch (err) {
    console.debug(err);
  }
}

export const getDomain = (url, dots = 1) => {
  return '//' + window.location.host.replace('backoffice.', '').replace('publisher.', '');
};

export const setViewerLastLocation = (lastLocation) => {
  if (lastLocation) {
    localStorage.setItem('viewerLastLocation', JSON.stringify(lastLocation));
  }
};

export const getViewerLastLocation = () => {
  return JSON.parse(localStorage.getItem('viewerLastLocation'));
};
